import { createClient } from '@connectrpc/connect';
import { GrowthBookService } from '@project-gd-x/dating-site-contracts/src/gen/gdx/growthbook/v1/service_connect';
import {
  ListFeaturesWithAttributesRequest,
  ListFeaturesWithAttributesResponse,
} from '@project-gd-x/dating-site-contracts/src/gen/gdx/growthbook/v1/service_pb';
import {
  Attribute,
  FeatureValue,
} from '@project-gd-x/dating-site-contracts/src/gen/gdx/growthbook/v1/types_pb';

import { getGrpcWebTransport } from '@/services/api/grpc-api';

const client = createClient(GrowthBookService, getGrpcWebTransport());

type ListFeaturesWithAttributesArg = {
  attributeMap: Record<string, unknown>;
  featureList: string[];
};
function listFeaturesWithAttributes(
  arg: ListFeaturesWithAttributesArg,
): Promise<ListFeaturesWithAttributesResponse> {
  const request = new ListFeaturesWithAttributesRequest({
    features: arg.featureList,
  });

  Object.entries(arg.attributeMap).forEach(([attrName, attrValue]) => {
    let featureValue: FeatureValue;
    if (typeof attrValue === 'boolean') {
      featureValue = new FeatureValue({
        val: {
          case: 'boolVal',
          value: attrValue,
        },
      });
    } else if (typeof attrValue === 'number') {
      featureValue = new FeatureValue({
        val: {
          case: 'floatVal',
          value: attrValue,
        },
      });
    } else {
      featureValue = new FeatureValue({
        val: {
          case: 'stringVal',
          value: attrValue as string,
        },
      });
    }

    request.attributes.push(
      new Attribute({
        name: attrName,
        value: featureValue,
      }),
    );
  });

  return client.listFeaturesWithAttributes(request);
}

export const growthbookApi = {
  listFeaturesWithAttributes,
};
